// EditEntryForm.js
import React, { useState, useEffect } from 'react';
import AuftragSelect from './AuftragSelect';
import { formatDate, formatDateForAPI, parseDateAsLocal } from '../utils/dateUtils';

const EditEntryForm = ({ entry, auftraege, stundenarten, onSubmit, onCancel, onDelete, auftragUsage = {} }) => {
  // Berechne das minimale und maximale Datum
  const today = new Date();
  const tenDaysAgo = new Date();
  tenDaysAgo.setDate(today.getDate() - 10);
  
  const maxDate = formatDateForAPI(today);
  const minDate = formatDateForAPI(tenDaysAgo);

  const [formData, setFormData] = useState({
    stuwebid: '',
    stuaufidref: '',
    stusaridref: '',
    studatum: '',
    stuanzahl: '',
    stubeschrieb: ''
  });

  useEffect(() => {
    if (entry) {
      setFormData({
        stuwebid: entry.StuPGID,
        stuaufidref: String(entry.StuAufIDRef),
        stusaridref: String(entry.StuSarIDRef),
        studatum: entry.StuDatum,
        stuanzahl: String(entry.StuAnzahl),
        stubeschrieb: entry.StuBeschrieb || ''
      });
    }
  }, [entry]);

  const handleSubmit = (e) => {
    e.preventDefault();
    try {
      // Validierung
      if (!formData.stuaufidref || !formData.stusaridref || !formData.studatum || !formData.stuanzahl) {
        throw new Error('Bitte füllen Sie alle Pflichtfelder aus.');
      }

      // Prüfe ob das Datum im erlaubten Bereich liegt
      // parseDateAsLocal verhindert UTC-Timezone-Verschiebung
      const selectedDate = parseDateAsLocal(formData.studatum);
      if (selectedDate < tenDaysAgo || selectedDate > today) {
        throw new Error('Das Datum muss innerhalb der letzten 10 Tage liegen.');
      }

      onSubmit({
        stuwebid: formData.stuwebid,
        stuaufidref: parseInt(formData.stuaufidref),
        stusaridref: parseInt(formData.stusaridref),
        studatum: formData.studatum,
        stuanzahl: parseFloat(formData.stuanzahl),
        stubeschrieb: formData.stubeschrieb
      });
    } catch (error) {
      console.error('Formularfehler:', error);
      alert(error.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleDelete = () => {
    if (onDelete && formData.stuwebid) {
      onDelete(formData.stuwebid);
    }
  };

  if (!entry) {
    return null;
  }

  const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    maxWidth: '400px'
  };

  const fieldStyle = {
    width: '100%'
  };

  const inputStyle = {
    width: '100%',
    padding: '10px',
    fontSize: '16px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    boxSizing: 'border-box'
  };

  return (
    <form onSubmit={handleSubmit} style={formStyle}>
      <div style={fieldStyle}>
        <label htmlFor="edit-studatum">Datum:</label>
        <input
          type="date"
          id="edit-studatum"
          name="studatum"
          value={formData.studatum}
          onChange={handleChange}
          min={minDate}
          max={maxDate}
          required
          style={inputStyle}
        />
      </div>

      <div style={fieldStyle}>
        <label htmlFor="edit-stuaufidref">Auftrag:</label>
        <AuftragSelect
          id="edit-stuaufidref"
          name="stuaufidref"
          value={formData.stuaufidref}
          onChange={handleChange}
          auftraege={auftraege}
          auftragUsage={auftragUsage}
          style={inputStyle}
        />
      </div>

      <div style={fieldStyle}>
        <label htmlFor="edit-stuanzahl">Stunden:</label>
        <input
          type="number"
          id="edit-stuanzahl"
          name="stuanzahl"
          value={formData.stuanzahl}
          onChange={handleChange}
          step="0.05"
          min="0"
          required
          style={inputStyle}
        />
      </div>

      <div style={fieldStyle}>
        <label htmlFor="edit-stusaridref">Art:</label>
        <select
          id="edit-stusaridref"
          name="stusaridref"
          value={formData.stusaridref}
          onChange={handleChange}
          required
          style={inputStyle}
        >
          <option value="">Bitte wählen...</option>
          {stundenarten.map(art => (
            <option key={art.Sart} value={art.Sart}>
              {art.SarBezeichnung}
            </option>
          ))}
        </select>
      </div>

      <div style={fieldStyle}>
        <label htmlFor="edit-stubeschrieb">Beschreibung:</label>
        <input
          type="text"
          id="edit-stubeschrieb"
          name="stubeschrieb"
          value={formData.stubeschrieb}
          onChange={handleChange}
          style={inputStyle}
        />
      </div>

      <div className="button-group">
        <button type="submit" className="btn btn-primary">Speichern</button>
        <button type="button" className="btn btn-secondary" onClick={onCancel}>Abbrechen</button>
        {onDelete && (
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleDelete}
            style={{ backgroundColor: '#dc2626', color: 'white' }}
          >
            Löschen
          </button>
        )}
      </div>
    </form>
  );
};

export default EditEntryForm;